module.exports = __webpack_public_path__ + "nstatic/img/lxfs.b6b3e6eb.jpg";